import { Box, Button, ButtonProps, Flex } from '@chakra-ui/react'

import { ModalHeader } from '../Modal'

interface ConfirmationModalProps {
	title: string
	subTitle?: string
	onCancel: () => void
	onSubmit: () => void
	cancelText: string
	submitText: string
	cancelProps?: Omit<ButtonProps, 'onClick'>
	submitProps?: Omit<ButtonProps, 'onClick'>
}

export const ConfirmationModal = ({
	title,
	subTitle,
	onCancel,
	onSubmit,
	cancelText,
	submitText,
	cancelProps,
	submitProps
}: ConfirmationModalProps) => {
	return (
		<Box
			as="section"
			minH={{ base: '96dvh', md: 'unset' }}
			h={{ base: 'unset', md: '19.375rem', xl: '18.5rem' }}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			flexDirection="column"
			px={{ base: '2rem', md: '0' }}
		>
			<ModalHeader text={title} />

			{subTitle && (
				<Box
					textStyle="body-text-4"
					mt="1rem"
					textAlign="center"
				>
					{subTitle}
				</Box>
			)}

			<Flex
				mt="2.5rem"
				display="flex"
				gap={{ base: '1rem', md: '2rem' }}
				w="100%"
				flexDirection={{ base: 'column', md: 'row' }}
				justifyContent="center"
			>
				<Button
					variant="outline"
					colorScheme="gray"
					size="lg"
					maxW={{ base: '100%', md: '17.5rem' }}
					w="100%"
					h={{ base: '3rem', xl: '4rem' }}
					onClick={onCancel}
					{...cancelProps}
				>
					{cancelText}
				</Button>

				<Button
					variant="solid"
					colorScheme="brand"
					size="lg"
					onClick={onSubmit}
					maxW={{ base: '100%', md: '17.5rem' }}
					w="100%"
					h={{ base: '3rem', xl: '4rem' }}
					{...submitProps}
				>
					{submitText}
				</Button>
			</Flex>
		</Box>
	)
}
